import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $menuExpandTrigger: this.el._$('.header__menu-trigger--expand'),
      $menuCollapseTrigger: this.el._$('.header__menu-trigger--collapse'),
      $subMenuTriggers: this.el._$$('.header__nav-item--has-sub-menu .header__nav-link'),
      $navItemsWithSubMenu: this.el._$$('.header__nav-item--has-sub-menu'),
      $navLinks: this.el._$$('.header__nav-link'),
      $subNavLinks: this.el._$$('.header__sub-nav-link'),
    };

    this.expandMenuClass = 'header--menu-expanded';
    this.subNavExpandMenuClass = 'header__nav-item--expanded';
    this.subNavExpandedClass = 'header__nav-item--hovered';
    this.keyCode = Object.freeze({
      TAB: 9,
      RETURN: 13,
      ESC: 27,
      SPACE: 32,
      PAGEUP: 33,
      PAGEDOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40
    });

    this.setup();
  }

  addListeners() {
    this.dom.$menuExpandTrigger._on('click', this.expandMenu.bind(this));
    this.dom.$menuCollapseTrigger._on('click', this.collapseMenu.bind(this));
    this.dom.$subMenuTriggers._on('click', this.handleSubMenuTriggersClick.bind(this));
    this.dom.$navItemsWithSubMenu._on('mouseenter', this.handleNavItemHover.bind(this, true));
    this.dom.$navItemsWithSubMenu._on('mouseleave', this.handleNavItemHover.bind(this, false));
    this.dom.$navLinks._on('keydown', this.handleNavLinkKeyDown.bind(this));
    this.dom.$subNavLinks._on('keydown', this.handleSubNavLinkKeyDown.bind(this));
  }

  setup() {
    this.dom.$navLinks[0]?.removeAttribute?.('tabindex');
    this.dom.$navLinks.forEach((el, i) => { el.dataset.index = i });
    this.dom.$navItemsWithSubMenu.forEach(el => {
      const $subNavItems = el._$$('.header__sub-nav-link');
      $subNavItems.forEach((subLink, i) => { subLink.dataset.index = i });
    })
  }

  expandMenu() {
    this.el.classList.add(this.expandMenuClass);
  }

  collapseMenu() {
    this.el.classList.remove(this.expandMenuClass);
  }

  expandSubNav($nav) {
    const $link = $nav._$('.header__nav-link');
    $link.setAttribute('aria-expanded', 'true');
    $nav.classList.add(this.subNavExpandedClass);
  }

  collapseSubNav($nav) {
    const $link = $nav._$('.header__nav-link');
    $link.setAttribute('aria-expanded', 'false');
    $nav.classList.remove(this.subNavExpandedClass);
  }

  handleSubMenuTriggersClick(e) {
    const item = e.target.closest('.header__nav-item');
    item.classList.toggle(this.subNavExpandMenuClass);
  }

  handleNavItemHover(hovered, e) {
    if (hovered) {
      this.expandSubNav(e.target);
    } else {
      this.collapseSubNav(e.target);
    }
  }

  handleNavLinkKeyDown(e) {
    const $item = e.target.closest('.header__nav-item');
    const $subNavItems = $item._$$('.header__sub-nav-link');

    switch (e.keyCode) {
      case this.keyCode.SPACE:
      case this.keyCode.RETURN:
      case this.keyCode.DOWN:
        this.expandSubNav($item);
        this.setFocusToFirstItem($subNavItems);
        break;

      case this.keyCode.LEFT:
        this.setFocusToPreviousItem(e.target, this.dom.$navLinks);
        break;

      case this.keyCode.RIGHT:
        this.setFocusToNextItem(e.target, this.dom.$navLinks);
        break;

      case this.keyCode.UP:
        this.collapseSubNav($item);
        break;

      case this.keyCode.HOME:
      case this.keyCode.PAGEUP:
        this.setFocusToFirstItem(this.dom.$navLinks);
        break;

      case this.keyCode.END:
      case this.keyCode.PAGEDOWN:
        this.setFocusToLastItem(this.dom.$navLinks);
        break;

      case this.keyCode.TAB:
        this.collapseSubNav($item);
        break;

      case this.keyCode.ESC:
        this.collapseSubNav($item);
        break;

      default:
        break;
    }
  }

  handleSubNavLinkKeyDown(e) {
    const $item = e.target.closest('.header__nav-item');
    const $subNavItems = $item._$$('.header__sub-nav-link');

    switch (e.keyCode) {
      case this.keyCode.DOWN:
        this.setFocusToNextItem(e.target, $subNavItems);
        break;

      case this.keyCode.UP:
        this.setFocusToPreviousItem(e.target, $subNavItems);
        break;

      case this.keyCode.HOME:
      case this.keyCode.PAGEUP:
        this.setFocusToFirstItem($subNavItems);
        break;

      case this.keyCode.END:
      case this.keyCode.PAGEDOWN:
        this.setFocusToLastItem($subNavItems);
        break;

      case this.keyCode.TAB:
        this.collapseSubNav($item);
        break;

      case this.keyCode.ESC:
        this.collapseSubNav($item);
        this.setFocusToItem($item._$('.header__nav-link'), this.dom.$navLinks);
        break;

      default:
        break;
    }
  }

  setFocusToItem($item, $items) {
    if (!$items.length) return;
    const $current = $item;
    this.updateTabIndex($current, $items);
    $current.focus();
  }

  setFocusToPreviousItem($item, $items) {
    if (!$items.length) return;
    const index = parseInt($item.dataset.index, 10);
    const prevIndex = index === 0 ? $items.length - 1 : index - 1;
    const $current = $items[prevIndex];
    this.updateTabIndex($current, $items);
    $current.focus();
  }

  setFocusToNextItem($item, $items) {
    if (!$items.length) return;
    const index = parseInt($item.dataset.index, 10);
    const nextIndex = index === $items.length - 1 ? 0 : index + 1;
    const $current = $items[nextIndex];
    this.updateTabIndex($current, $items);
    $current.focus();
  }

  setFocusToFirstItem($items) {
    if (!$items.length) return;
    const $current = $items[0];
    this.updateTabIndex($current, $items);
    $current.focus();
  }

  setFocusToLastItem($items) {
    if (!$items.length) return;
    const $current = $items[$items.length - 1];
    this.updateTabIndex($current, $items);
    $current.focus();
  }

  updateTabIndex($current, $items) {
    $items.forEach(el => el.setAttribute('tabindex', -1));
    $current.removeAttribute('tabindex');
  }
}

export default Module;
